
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p/portfolio",
      function () {
        return require("private-next-pages/p/portfolio/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/p/portfolio"])
      });
    }
  